<template>
  <div>
    <order-edit ref="edit" :show="orderEditShow" :edit-id="orderEditId" @close="closeEdit" />
  </div>
</template>
<script>
import {loadEnum} from "@/utils/enum";

export default {
  name: 'AuthRedirect',
  data(){
    return {
      orderEditShow:false,
      orderEditId:0,
      businessType:null,
      businessId:0,
    }
  },
  created() {
    this.businessId = this.$route.query.businessId
    this.businessType = this.$route.query.businessType
    this.oaLogin(this.$route.query.code)
  },
  render: function(h) {
    return h() // avoid warning message
  },
  methods:{
    showEdit(){
      if(this.businessType && this.businessType=='订单'){
        this.orderEditShow = true
        this.orderEditId = this.businessId
        return true
      }
      return false
    },
    closeEdit(){
      window.close()
    },
    oaLogin(hash){
      this.$store.dispatch('user/loginOa', hash)
        .then(() => {
          // 加载枚举信息
          loadEnum()
          if(!this.showEdit()){
            this.$router.push({ path: '/index'})
          }
          this.loading = false
        })
        .catch(() => {
          this.loading = false
        })
    }
  }
}
</script>
